
// // ─────────────────────────────────────────────────────────────────────────────
// import { useState, useEffect } from "react";
// import axios from "axios";
// import { useAuth } from '../../context/AuthContext';
// import { Box, Grid, Typography, Button, Paper, useTheme, useMediaQuery, Stepper, StepLabel, Step } from "@mui/material";
// import dayjs from "dayjs";
// import PaymentReceiptStepOne from "../../components/PaymentReceiptStepOne";
// import PaymentReceiptStepTwo from "../../components/PaymentReceiptStepTwo";

// export default function ReceiveableV2({ connectionString }) {
//     const { user, selectedCompany, loading } = useAuth();
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory || null;
//     const path = connectionString;
//     const theme = useTheme();
//     const isSm = useMediaQuery(theme.breakpoints.down("sm"));
//     const today = dayjs();
//     // --- Lookup state
//     const [bookType, setBookType] = useState("");
//     const [cashBookTerm, setCashBookTerm] = useState("");
//     const [cashBookOptions, setCashBookOptions] = useState([]);
//     const [loadingCashBook, setLoadingCashBook] = useState(false);
//     const [selectedCashBook, setSelectedCashBook] = useState(null);
//     const [partyInput, setPartyInput] = useState("");
//     const [partyOptions, setPartyOptions] = useState([]);
//     const [selectedParty, setSelectedParty] = useState(null);
//     const [loadingParty, setLoadingParty] = useState(false);
//     const [isMultiCurrency, setIsMultiCurrency] = useState(false);
//     const [selectedCurrency, setSelectedCurrency] = useState(null);
//     const [exchangeRate, setExchangeRate] = useState("");
//     const [receiptNo, setReceiptNo] = useState("");
//     // --- Numeric fields
//     const [amount, setAmount] = useState("");
//     const [tds, setTds] = useState("");
//     const [roundOff, setRoundOff] = useState("0");
//     const [totalAmt, setTotalAmt] = useState("");
//     const [remark, setRemark] = useState("");
//     const [receiptDate, setReceiptDate] = useState(dayjs());
//     const [bankCharges, setBankCharges] = useState("");
//     // Payment type & tables
//     const [paymentType, setPaymentType] = useState("OnAccount");
//     const [invoiceData, setInvoiceData] = useState([]);
//     const [selectedBills, setSelectedBills] = useState([]);
//     const [transactionNo, setTransactionNo] = useState("");
//     const [loadingInvoices, setLoadingInvoices] = useState(false);
//     // Error states
//     const [errors, setErrors] = useState({
//         bookType: false,
//         receiptNo: false,
//         selectedCashBook: false,
//         selectedParty: false,
//         amount: false,
//         inputAmount: {},
//         transactionNo: false,
//     });

//     // Modal states
//     const [open, setOpen] = useState(false);
//     const [pendingSelectedIds, setPendingSelectedIds] = useState([]);
//     const [fetchedPartyId, setFetchedPartyId] = useState(null);

//     //stepper states
//     const [activeStep, setActiveStep] = useState(0);
//     const steps = ["Step-1", "Step-2"];

//     //used to make next button disable
//     const isStep1ValidForBillWise =
//         Boolean(bookType) &&
//         Boolean(selectedCashBook) &&
//         Boolean(selectedParty) &&
//         Boolean(transactionNo)&&
//         amount.toString().trim() !== "" &&
//         parseFloat(amount) > 0;

//     // Reset invoiceData and selectedBills when party changes
//     useEffect(() => {
//         setInvoiceData([]);
//         setSelectedBills([]);
//         setFetchedPartyId(null);
//     }, [selectedParty?.id]);

//     // Helper to reset all errors
//     const clearErrors = () => {
//         setErrors({
//             bookType: false,
//             receiptNo: false,
//             selectedCashBook: false,
//             selectedParty: false,
//             amount: false,
//             inputAmount: {},
//             transactionNo: false,
//         });
//     };

//     // Disable Save if any single inputAmount exceeds the Amount
//     const disableSave = selectedBills.some((inv) => {
//         const applied = parseFloat(inv.inputAmount) || 0;
//         const allowed = parseFloat(amount) || 0;
//         return applied > allowed;
//     });

//     // Debounced cash-book lookup
//     useEffect(() => {
//         if (!cashBookTerm.trim() || !bookType) {
//             setCashBookOptions([]);
//             return;
//         }
//         setLoadingCashBook(true);
//         const id = setTimeout(async () => {
//             try {
//                 const res = await axios.get(`${path}/api/booktype-data`, { params: { field: bookType, search: cashBookTerm, companyId }, });
//                 setCashBookOptions(res.data.data || []);
//             } catch {
//                 setCashBookOptions([]);
//             } finally {
//                 setLoadingCashBook(false);
//             }
//         }, 500);
//         return () => clearTimeout(id);
//     }, [cashBookTerm, bookType]);


//     // Receipt number
//     const fetchReceiptNo = async (code) => {
//         try {
//             const { data } = await axios.get(`${path}/api/get-receipt-no`, { params: { code, companyId }, });
//             setReceiptNo(data.receiptNo || "");
//         } catch {
//             setReceiptNo("");
//         }
//     };

//     console.log("selectedCashBook", selectedCashBook)

//     const handleBookTypeChange = (e) => {
//         const val = e.target.value;
//         setBookType(val);
//         fetchReceiptNo(val === "Bank Receipt" ? "BR" : "CR");
//     };

//     // Party lookup
//     useEffect(() => {
//         setLoadingParty(true);
//         const id = setTimeout(async () => {
//             try {
//                 const res = await axios.get(`${path}/api/company-search`, { params: { field: "FirmName", companyId, search: partyInput.trim() || "" }, });
//                 const mappedOptions = (res.data.data || []).map((item) => ({
//                     id: item.id,
//                     clientname: item.FirmName,
//                     ContactPerson: item.ContactPerson,
//                     City: item.City,
//                     MobileNo: item.MobileNo,
//                     EmailId: item.EmailId,
//                     Address: item.Address,
//                     GSTNo: item.GSTNo,
//                     state: item.state,
//                     Pincode: item.Pincode,
//                 }));
//                 setPartyOptions(mappedOptions);
//             } catch {
//                 setPartyOptions([]);
//             } finally {
//                 setLoadingParty(false);
//             }
//         }, 500);
//         return () => clearTimeout(id);
//     }, [partyInput]);

//     console.log("selectedCurrency", selectedCurrency)

//     // Recompute overall totalAmt
//     useEffect(() => {
//         const a = parseFloat(amount) || 0;
//         const t = parseFloat(tds) || 0;
//         const r = parseFloat(roundOff) || 0;
//         setTotalAmt((a + t + r).toFixed(2));
//     }, [amount, tds, roundOff]);

//     // Clear currency on toggle
//     useEffect(() => {

//         if (!isMultiCurrency) {
//             console.log("inside multicurrency******")
//             // setCurrencySearch("");
//             // setCurrencyResults([]);
//             setSelectedCurrency(null);
//             setExchangeRate("");
//         }
//     }, [isMultiCurrency]);

//     // Handle Save
//     const handleSave = async () => {
//         if (disableSave) return;
//         // Reset previous errors
//         clearErrors();

//         // Run validation
//         let valid = true;
//         if (!bookType) {
//             setErrors((e) => ({ ...e, bookType: true }));
//             valid = false;
//         }
//         if (!receiptNo) {
//             setErrors((e) => ({ ...e, receiptNo: true }));
//             valid = false;
//         }
//         if (!selectedCashBook) {
//             setErrors((e) => ({ ...e, selectedCashBook: true }));
//             valid = false;
//         }
//         if (!selectedParty) {
//             setErrors((e) => ({ ...e, selectedParty: true }));
//             valid = false;
//         }
//         if (amount.toString().trim() === "") {
//             setErrors((e) => ({ ...e, amount: true }));
//             valid = false;
//         }
//         if (transactionNo.toString().trim() === "") {
//             setErrors((e) => ({ ...e, transactionNo: true }));
//             valid = false;
//         }

//         // If BillWise, ensure each line has an inputAmount
//         if (paymentType === "BillWise") {
//             selectedBills.forEach((inv) => {
//                 if (inv.inputAmount == null || inv.inputAmount.toString().trim() === "") {
//                     setErrors((e) => ({ ...e, inputAmount: { ...e.inputAmount, [inv.SaleInvoiceId]: true }, }));
//                     valid = false;
//                 }
//             });
//         }

//         // Stop if any validation failed
//         if (!valid) {
//             alert("Please fill in all required fields.");
//             return;
//         }



//         // Map each selected bill to billwiseentry
//         const billWiseEntries = selectedBills.map((inv, idx) => {
//             const amt = parseFloat(inv.inputAmount) || 0;
//             const tdsAmt = parseFloat(inv.inputTds) || 0;
//             const roundOffAmt = parseFloat(inv.inputRoundOff) || 0;
//             const totalPaid = amt + tdsAmt + roundOffAmt;

//             return {
//                 saleInvoiceId: inv.SaleInvoiceId,
//                 SrNo: idx + 1,
//                 BillAmt: parseFloat(inv.BasicAmt) || 0,
//                 OSAMT: (parseFloat(inv.BillAmt) || 0) - amt,
//                 ChequeAmt: amt,
//                 TDSAmt: tdsAmt,
//                 RoundOffAmt: roundOffAmt,
//                 PaidAmt: totalPaid,
//                 InvoiceId: inv.SaleInvoiceId,
//                 Inv_BillNumber: inv.BillNumber,
//                 Inv_BillDate: inv.BillDate,
//                 Inv_BillAmt: parseFloat(inv.BillAmt) || 0,
//             };
//         });

//         const payload = {
//             L_NO: null,
//             PartyId: selectedParty?.id || null,
//             BankId: selectedCashBook?.id || null,
//             BookName: bookType || null,
//             ReceiptNumber: receiptNo || null,
//             ReceiptDate: receiptDate?.toISOString() || null,
//             ChequeNo: transactionNo || null,
//             Amount: amount ? parseFloat(amount) : null,
//             BankComm: bankCharges ? parseFloat(bankCharges) : 0,
//             TDSAmt: tds ? parseFloat(tds) : null,
//             RoundOffAmt: roundOff ? parseFloat(roundOff) : null,
//             PaidAmt: totalAmt ? parseFloat(totalAmt) : null,
//             VoucherNo: 0,
//             VoucherTotal: totalAmt ? parseFloat(totalAmt) : null,
//             Remarks: remark || null,
//             ClearingAmount: 0,
//             ClearingDate: null,
//             CurrencyId: selectedCurrency?.currencyId || null,
//             ExchangeRate: exchangeRate ? parseFloat(exchangeRate) : null,
//             MultiCurrency: isMultiCurrency ? 1 : 0,
//             FYear: getCurrentFYear(),
//             CompanyId: companyId,
//             BranchId: 1,
//             AddUserId: userId,
//             BillWise: paymentType === "BillWise" ? 1 : 0,
//             BillWisePaidAmt: totalAmt ? parseFloat(totalAmt) : null,
//             billWiseEntries,
//         };

//         console.log("payload", payload)

//         // try {
//         //     const res = await axios.post(`${path}/api/receivable`, payload);
//         //     if (res.data.success) {
//         //         alert(`Saved! New Receipt ID: ${res.data.receiptId}`);
//         //         handleClear();
//         //     } else {
//         //         alert("Save failed");
//         //     }
//         // } catch (err) {
//         //     console.error(err);
//         //     alert("Error saving receivable");
//         // }
//     };

//     const handleClear = () => {
//         setBookType("");
//         setCashBookTerm("");
//         setCashBookOptions([]);
//         setSelectedCashBook(null);
//         setPartyInput("");
//         setPartyOptions([]);
//         setSelectedParty(null);
//         setIsMultiCurrency(false);
//         // setCurrencySearch("");
//         // setCurrencyResults([]);
//         setSelectedCurrency(null);
//         setExchangeRate("");
//         setReceiptNo("");
//         setAmount("");
//         setTds("");
//         setRoundOff("0");
//         setTotalAmt("");
//         setReceiptDate(today);
//         setPaymentType("BillWise");
//         setRemark("");
//         setInvoiceData([]);
//         setSelectedBills([]);
//         setBankCharges("");
//         setPendingSelectedIds([]);
//         setFetchedPartyId(null);
//         clearErrors();
//     };

//    //fetches invoices and moves to next step
//     const handleNextButton = async () => {
//         // Reset previous errors
//         clearErrors();

//         let valid = true;
//         if (!bookType) {
//             setErrors(e => ({ ...e, bookType: true }));
//             valid = false;
//         }

//         if (!transactionNo) {
//             setErrors(e => ({ ...e, transactionNo: true }));
//             valid = false;
//         }

//           if (!selectedCashBook) {
//             setErrors(e => ({ ...e, selectedCashBook: true }));
//             valid = false;
//           }

//         if (!selectedParty) {
//             setErrors(e => ({ ...e, selectedParty: true }));
//             valid = false;
//         }

//         if (amount.toString().trim() === "" || parseFloat(amount) <= 0) {
//             setErrors(e => ({ ...e, amount: true }));
//             valid = false;
//         }

//         if (!valid) {
//             alert("Please fill required fields before viewing outstanding entries.");
//             return;
//         }

//         if (!selectedParty?.id) {
//             alert("Please select a party first.");
//             return;
//         }
//         if (fetchedPartyId !== selectedParty.id) {
//             setLoadingInvoices(true);
//             try {
//                 const res = await axios.post(`${path}/api/fetch-invoice-by-client`, {
//                     clientId: selectedParty.id,
//                     clientName: selectedParty.clientname,
//                     companyId,
//                     mode: 'sale'
//                 });
//                 const invoicesWithIndex = (res.data.invoices || []).map((inv, index) => ({
//                     ...inv,
//                     id: inv.SaleInvoiceId,
//                     originalIndex: index,
//                     BasicAmt: Number(inv.BasicAmt),
//   RoundOff: Number(inv.RoundOff),
//   BillAmt: Number(inv.BillAmt),
//   PaidAmt: Number(inv.PaidAmt)
//                 }));
//                 setInvoiceData(invoicesWithIndex);
//                 setFetchedPartyId(selectedParty.id);
//             } catch (err) {
//                 console.error(err);
//                 alert("Error fetching invoices.");
//             } finally {
//                 setLoadingInvoices(false);
//             }
//         }
//         setPendingSelectedIds([]);
//         setOpen(true);
//         setActiveStep(1)
//     };

// // Removes an invoice from the selected Bill Wise list
// // and adds it back to the pending invoices list at its original position
//     const handleDeselectInvoice = (invoice) => {
//         setSelectedBills((prev) => prev.filter((i) => i.SaleInvoiceId !== invoice.SaleInvoiceId));
//         setInvoiceData((prev) => {
//             const newData = [...prev];
//             const index = invoice.originalIndex || prev.length;
//             newData.splice(index, 0, {
//                 SaleInvoiceId: invoice.SaleInvoiceId,
//                 BillNumber: invoice.BillNumber,
//                 RefNo: invoice.RefNo,
//                 BillDate: invoice.BillDate,
//                 BasicAmt: invoice.BasicAmt,
//                 RoundOff: invoice.RoundOff,
//                 BillAmt: invoice.BillAmt,
//                 PaidAmt: invoice.PaidAmt,
//                 id: invoice.SaleInvoiceId,
//                 originalIndex: invoice.originalIndex,
//             });
//             return newData;
//         });
//     };

//     // Updates a specific input field (amount / TDS / round-off) 
//    // for a selected invoice in the Bill Wise table
//     const handleBillFieldChange = (saleInvoiceId, field, value) => {
//         setSelectedBills((prev) =>
//             prev.map((inv) => {
//                 if (inv.SaleInvoiceId !== saleInvoiceId) return inv;
//                 if (field === "inputTotalAmount") return inv;
//                 return { ...inv, [field]: value };
//             })
//         );
//     };

//     // Move selected invoices from pending list to Bill Wise list
//     const handleSubmitSelected = () => {
//         // Get selected invoices based on pendingSelectedIds
//         const selectedInvoices = invoiceData.filter((inv) =>
//             pendingSelectedIds.includes(inv.SaleInvoiceId)
//         );

//         // Map selected invoices to include input fields
//         const toAdd = selectedInvoices.map((invoice) => ({
//             ...invoice,
//             inputAmount: invoice.BasicAmt || "",
//             inputTds: "",
//             inputRoundOff: "",
//             inputTotalAmount: invoice.BillAmt || "",
//         }));

//         // Update selectedBills by adding new selections
//         setSelectedBills((prev) => [...prev, ...toAdd]);

//         // Remove selected invoices from invoiceData
//         setInvoiceData((prev) =>
//             prev.filter((inv) => !pendingSelectedIds.includes(inv.SaleInvoiceId))
//         );

//         // Clear selected IDs and close dialog
//         setPendingSelectedIds([]);
//         setOpen(false);
//     };


//     return (
//         <Box sx={{ width: "100%", p: isSm ? 1 : 2, overflow: "auto" }}>
//             <Typography
//                 variant={isSm ? "h5" : "h4"}
//                 align="center"
//                 gutterBottom
//                 sx={{ textDecoration: "underline", mb: isSm ? 1 : 2, fontSize: isSm ? "1.25rem" : "2rem" }}
//             >
//                 Payment Receipt
//             </Typography>

//             <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3 }}>
//                 {steps.map((label) => (
//                     <Step key={label}>
//                         <StepLabel>{label}</StepLabel>
//                     </Step>
//                 ))}
//             </Stepper>

//             <Paper elevation={2} sx={{ p: isSm ? 1 : 2, maxWidth: 1400, mx: "auto", overflow: "hidden" }}>
//                 <Grid container spacing={isSm ? 1 : 2} justifyContent="center">
//                     {/* *********step-1******** */}
//                     {
//                         activeStep === 0 &&
//                         <Grid item size={{xs:12 , md:6}}>
//                             <PaymentReceiptStepOne
//                                 bookType={bookType}
//                                 errors={errors}
//                                 handleBookTypeChange={handleBookTypeChange}
//                                 paymentType={paymentType}
//                                 setPaymentType={setPaymentType}
//                                 setBookType={setBookType}
//                                 selectedCashBook={selectedCashBook}
//                                 setSelectedCashBook={setSelectedCashBook}
//                                 selectedParty={selectedParty}
//                                 setSelectedParty={setSelectedParty}
//                                 amount={amount}
//                                 setAmount={setAmount}
//                                 receiptDate={receiptDate}
//                                 setReceiptDate={setReceiptDate}
//                                 receiptNo={receiptNo}
//                                 cashBookOptions={cashBookOptions}
//                                 cashBookTerm={cashBookTerm}
//                                 setCashBookTerm={setCashBookTerm}
//                                 loadingCashBook={loadingCashBook}
//                                 partyOptions={partyOptions}
//                                 partyInput={partyInput}
//                                 setPartyInput={setPartyInput}
//                                 loadingParty={loadingParty}
//                                 transactionNo={transactionNo}
//                                 setTransactionNo={setTransactionNo}
//                                 tds={tds}
//                                 setTds={setTds}
//                                 roundOff={roundOff}
//                                 setRoundOff={setRoundOff}
//                                 totalAmt={totalAmt}
//                                 isMultiCurrency={isMultiCurrency}
//                                 setIsMultiCurrency={setIsMultiCurrency}
//                                 selectedCurrency={selectedCurrency}
//                                 setSelectedCurrency={setSelectedCurrency}
//                                 exchangeRate={exchangeRate}
//                                 setExchangeRate={setExchangeRate}
//                                 bankCharges={bankCharges}
//                                 setBankCharges={setBankCharges}
//                                 remark={remark}
//                                 setRemark={setRemark}
//                                 handleNextButton={handleNextButton}
//                                 isStep1ValidForBillWise={isStep1ValidForBillWise}
//                                 connectionString={connectionString}
//                             />
//                         </Grid>
//                     }
//                 </Grid>

//                 {/* *********step-2******** */}
//                 {activeStep === 1 &&
//                     <>
//                         <PaymentReceiptStepTwo
//                             invoiceData={invoiceData}
//                             selectedBills={selectedBills}
//                             pendingSelectedIds={pendingSelectedIds}
//                             setPendingSelectedIds={setPendingSelectedIds}
//                             loadingInvoices={loadingInvoices}
//                             handleSubmitSelected={handleSubmitSelected}
//                             setOpen={setOpen}
//                             paymentType={paymentType}
//                             handleSave={handleSave}
//                             handleClear={handleClear}
//                             disableSave={disableSave}
//                             handleBillFieldChange={handleBillFieldChange}
//                             handleDeselectInvoice={handleDeselectInvoice}
//                             errors={errors}
//                             amount={amount}

//                         />

//                         {/* Navigation go back to step-1 */}
//                         <Box sx={{ textAlign: "center", mt: 3 }}>
//                             <Button sx={{ mr: 2 }} onClick={() => setActiveStep(0)}>
//                                 Back
//                             </Button>
//                         </Box>
//                     </>}
//             </Paper>


//         </Box>
//     );
// }





// // ─────────────────────────────────────────────────────────────────────────────
// // src/Pages/Payable/PayableV2.jsx  —  DESIGN LAYER
// //
// // ┌─────────────────────────────────────────────────────────────────────────┐
// // │  Module  : Payable                                                     │
// // │  Role    : Accounts payable — payable ledger and vouchers                                                       │
// // ├─────────────────────────────────────────────────────────────────────────┤
// // │    ✅ JSX render tree                                                    │
// // │    ✅ useTheme() for dark/light colour tokens                            │
// // │    ✅ Layout, spacing, responsive breakpoints                            │
// // │    ❌ NO useState/useEffect/axios → see PayableV2.logic.js                 │
// // └─────────────────────────────────────────────────────────────────────────┘
// //
// // Dark-mode:  const theme = useTheme();  const isDark = theme.palette.mode === "dark";
// // Logic split: PayableV2.logic.js  ←→  PayableV2.jsx
// // ─────────────────────────────────────────────────────────────────────────────
// import { useState, useEffect } from "react";
// import axios from "axios";
// import { useAuth } from '../../context/AuthContext';
// import { Box, Grid, Typography, Button, Paper, useTheme, useMediaQuery, Stepper, StepLabel, Step, Divider } from "@mui/material";
// import dayjs from "dayjs";
// import PaymentReceiptStepOne from "../../components/PaymentReceiptStepOne";
// import PaymentReceiptStepTwo from "../../components/PaymentReceiptStepTwo";
// import { Snackbar, Alert } from "@mui/material";

// export default function PayableV2({ connectionString }) {
//     const { user, selectedCompany, loading } = useAuth();
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory || null;
//     const path = connectionString;
//     const theme = useTheme();
//     const isSm = useMediaQuery(theme.breakpoints.down("sm"));
//     const today = dayjs();
//     // --- Lookup state
//     const [bookType, setBookType] = useState("Bank Receipt");
//     const [cashBookTerm, setCashBookTerm] = useState("");
//     const [cashBookOptions, setCashBookOptions] = useState([]);
//     const [loadingCashBook, setLoadingCashBook] = useState(false);
//     const [selectedCashBook, setSelectedCashBook] = useState(null);
//     const [partyInput, setPartyInput] = useState("");
//     const [partyOptions, setPartyOptions] = useState([]);
//     const [selectedParty, setSelectedParty] = useState(null);
//     const [loadingParty, setLoadingParty] = useState(false);
//     const [isMultiCurrency, setIsMultiCurrency] = useState(false);
//     const [currencyResults, setCurrencyResults] = useState([]);
//     const [selectedCurrency, setSelectedCurrency] = useState(null);
//     const [exchangeRate, setExchangeRate] = useState("");
//     const [receiptNo, setReceiptNo] = useState("");
//     // --- Numeric fields
//     const [amount, setAmount] = useState("");
//     const [tds, setTds] = useState("");
//     const [roundOff, setRoundOff] = useState("0");
//     const [totalAmt, setTotalAmt] = useState("");
//     const [remark, setRemark] = useState("");
//     const [receiptDate, setReceiptDate] = useState(dayjs());
//     const [bankCharges, setBankCharges] = useState("");
//     // Payment type & tables
//     const [paymentType, setPaymentType] = useState("BillWise");
//     const [invoiceData, setInvoiceData] = useState([]);
//     const [selectedBills, setSelectedBills] = useState([]);
//     const [transactionNo, setTransactionNo] = useState("");
//     const [loadingInvoices, setLoadingInvoices] = useState(false);

//     const [allInvoices, setAllInvoices] = useState([]);

//     const formMode =  "receipt";

//     const bookTypeOptions = {
//     payment: [
//         { label: "Bank Payment", value: "Bank Payment" },
//         { label: "Cash Payment", value: "Cash Payment" }
//     ],
//     receipt: [
//         { label: "Bank Receipt", value: "Bank Receipt" },
//         { label: "Cash Receipt", value: "Cash Receipt" }
//     ]
// };

//     // Error states
//     const [errors, setErrors] = useState({ bookType: false, receiptNo: false, selectedCashBook: false, selectedParty: false, amount: false, inputAmount: {}, transactionNo: false, });

//     // Modal states
//     const [modalOpen, setModalOpen] = useState(false);
//     const [pendingSelectedIds, setPendingSelectedIds] = useState([]);
//     const [fetchedPartyId, setFetchedPartyId] = useState(null);

//     const [bankCashConfig, setBankCashConfig] = useState(null);
//     const [isConfigInvalid, setIsConfigInvalid] = useState(false);
//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: "",
//         severity: "success" // success | error | warning | info
//     });


//     //stepper states
//     const [activeStep, setActiveStep] = useState(0);
//     const steps = ["Step-1", "Step-2"];



//     //used to make next button disable
//     const isStep1ValidForBillWise = Boolean(bookType) && Boolean(selectedCashBook) && Boolean(selectedParty) && (bookType !== "Bank Receipt" || Boolean(transactionNo)) && amount.toString().trim() !== "" && parseFloat(amount) > 0;

//     // Reset invoiceData and selectedBills when party changes
//     useEffect(() => {
//         setInvoiceData([]);
//         setSelectedBills([]);
//         setFetchedPartyId(null);
//     }, [selectedParty?.id]);

//     const showSnackbar = (message, severity = "success") => {
//         setSnackbar({
//             open: true,
//             message,
//             severity
//         });
//     };

//     //function to auto select bills according to the billDate
//     const handleAutoSelectBills = () => {
//         if (!allInvoices || allInvoices.length === 0) return;

//         const sorted = [...allInvoices].sort(
//             (a, b) => new Date(a.BillDate) - new Date(b.BillDate)
//         );

//         let remaining = parseFloat(amount) || 0;
//         const selected = [];

//         for (let bill of sorted) {
//             if (remaining <= 0) break;

//             const billAmt = parseFloat(bill.OSAmt) || 0;

//             //  If full bill fits
//             if (billAmt <= remaining) {
//                 selected.push({
//                     ...bill,
//                     inputAmount: billAmt,
//                     inputTds: "",
//                     inputRoundOff: "",
//                     inputTotalAmount: billAmt,
//                 });

//                 remaining -= billAmt;
//             } else {
//                 //  PARTIAL ALLOCATION (IMPORTANT)
//                 selected.push({
//                     ...bill,
//                     inputAmount: remaining,
//                     inputTds: "",
//                     inputRoundOff: "",
//                     inputTotalAmount: remaining,
//                 });

//                 remaining = 0;
//             }
//         }

//         const selectedIds = selected.map(b => b.invoiceId);

//         //  FULL RESET every time (as per your requirement)
//         setSelectedBills(selected);

//         //  Remaining invoices go back to pending
//         setInvoiceData(allInvoices.filter(b => !selectedIds.includes(b.invoiceId)));
//     };
//     const fetchBankCashConfig = async (bookName) => {
//         try {
//             const res = await axios.get(`${path}/api/check-bankcash-config`, {
//                 params: {
//                     compId: companyId,
//                     bookName
//                 }
//             });

//             setBankCashConfig(res.data.data || []);
//         } catch (err) {
//             console.error("Config fetch error", err);
//             setBankCashConfig(null);
//         }
//     };

//     //fetch  tds , bank charge , round off exist info
//     useEffect(() => {
//         if (!bookType) return;

//         // Map UI → DB BookName
//         let bookName = "";
//         if (bookType === "Bank Receipt") bookName = "BKR";
//         else if (bookType === "Bank Payment") bookName = "BKP";
//         else if (bookType === "Cash Receipt") bookName = "CBR";
//         else if (bookType === "Cash Payment") bookName = "CBP";

//         if (bookName) {
//             fetchBankCashConfig(bookName);
//         }

//     }, [bookType, companyId]);


//     //Trigger receipt generation on load
//     useEffect(() => {
//         if (bookType) {
//             const code = bookType === "Bank Receipt" ? "BR" : "CR";
//             fetchReceiptNo(code);
//         }
//     }, [bookType]);


//     // UI state reset on bookType change
//     useEffect(() => {
//         if (bookType === "Cash Receipt") {
//             setTransactionNo("");
//             setBankCharges("");
//         }
//         setSelectedCashBook(null);
//     }, [bookType]);

//     // Helper to reset all errors
//     const clearErrors = () => {
//         setErrors({ bookType: false, receiptNo: false, selectedCashBook: false, selectedParty: false, amount: false, inputAmount: {}, transactionNo: false, });
//     };

//     const fetchCurrency = async () => {
//         try {
//             const res = await axios.get(`${path}/currencymaster/search?mode=search&companyId=${companyId}`);

//             // IMPORTANT: set data into state
//             setCurrencyResults(res.data || []);
//         } catch (err) {
//             console.error(err);
//             setCurrencyResults([]);
//         }
//     };

//     useEffect(() => {
//         fetchCurrency()
//     }, [])


//     // Add row error check
//     const hasRowError = selectedBills.some((row) => {
//         const total =
//             (parseFloat(row.inputAmount) || 0) +
//             (parseFloat(row.inputTds) || 0) +
//             (parseFloat(row.inputRoundOff) || 0);

//         return total > parseFloat(row.OSAmt);
//     });


//     // Disable Save if any single inputAmount exceeds the Amount or any error
//     const disableSave = (() => {
//         const enteredAmount = parseFloat(amount) || 0;
//         const enteredTds = parseFloat(tds) || 0;
//         const enteredRoundOff = parseFloat(roundOff) || 0;
//         const enteredTotal = parseFloat(totalAmt) || 0;

//         const appliedAmount = selectedBills.reduce(
//             (sum, i) => sum + (parseFloat(i.inputAmount) || 0),
//             0
//         );

//         const appliedTds = selectedBills.reduce(
//             (sum, i) => sum + (parseFloat(i.inputTds) || 0),
//             0
//         );

//         const appliedRoundOff = selectedBills.reduce(
//             (sum, i) => sum + (parseFloat(i.inputRoundOff) || 0),
//             0
//         );

//         const appliedTotal = appliedAmount + appliedTds + appliedRoundOff;

//         const mismatch =
//             appliedAmount.toFixed(2) !== enteredAmount.toFixed(2) ||
//             appliedTds.toFixed(2) !== enteredTds.toFixed(2) ||
//             appliedRoundOff.toFixed(2) !== enteredRoundOff.toFixed(2) ||
//             appliedTotal.toFixed(2) !== enteredTotal.toFixed(2);

//         // FINAL CONDITION
//         return hasRowError || mismatch;
//     })();

//     // Debounced cash-book lookup
//     useEffect(() => {
//         if (!bookType) {
//             setCashBookOptions([]);
//             return;
//         }
//         setLoadingCashBook(true);
//         const id = setTimeout(async () => {
//             try {
//                 // console.log({ params: { field: bookType, search: cashBookTerm, companyId }, })
//                 const res = await axios.get(`${path}/api/booktype-data`, { params: { field: bookType, search: cashBookTerm, companyId }, });
//                 setCashBookOptions(res.data.data || []);
//                 console.log('asgbisdbgf', res.data.data)
//             } catch {
//                 setCashBookOptions([]);
//             } finally {
//                 setLoadingCashBook(false);
//             }
//         }, 500);
//         return () => clearTimeout(id);
//     }, [cashBookTerm, bookType]);

//     // Receipt number
//     const fetchReceiptNo = async (code) => {
//         try {
//             const { data } = await axios.get(`${path}/api/get-receipt-no`, { params: { code, companyId }, });
//             setReceiptNo(data.receiptNo || "");
//         } catch {
//             setReceiptNo("");
//         }
//     };

//     console.log("selectedCashBook", selectedCashBook)
//     const handleBookTypeChange = (e) => {
//         setBookType(e.target.value);
//     };

//     // Party lookup
//     useEffect(() => {
//         setLoadingParty(true);
//         const id = setTimeout(async () => {
//             try {
//                 const res = await axios.get(`${path}/api/company-search`, { params: { field: "FirmName", companyId, search: partyInput.trim() || "" }, });
//                 const mappedOptions = (res.data.data || []).map((item) => ({ id: item.id, clientname: item.FirmName, ContactPerson: item.ContactPerson, City: item.City, MobileNo: item.MobileNo, EmailId: item.EmailId, Address: item.Address, GSTNo: item.GSTNo, state: item.state, Pincode: item.Pincode, }));
//                 setPartyOptions(mappedOptions);
//             } catch {
//                 setPartyOptions([]);
//             } finally {
//                 setLoadingParty(false);
//             }
//         }, 500);
//         return () => clearTimeout(id);
//     }, [partyInput]);

//     console.log("selectedCurrency", selectedCurrency)

//     // Recompute overall totalAmt
//     useEffect(() => {
//         const a = parseFloat(amount) || 0;
//         const t = parseFloat(tds) || 0;
//         const r = parseFloat(roundOff) || 0;
//         setTotalAmt((a + t + r).toFixed(2));
//     }, [amount, tds, roundOff]);

//     // Clear currency on toggle
//     useEffect(() => {

//         if (!isMultiCurrency) {
//             console.log("inside multicurrency******")
//             // setCurrencySearch("");
//             // setCurrencyResults([]);
//             setSelectedCurrency(null);
//             setExchangeRate("");
//         }
//     }, [isMultiCurrency]);

//     // Handle Save
//     const handleSave = async () => {
//         if (paymentType === "BillWise" && disableSave) return;
//         // Reset previous errors

//         clearErrors();

//         // Run validation
//         let valid = true;
//         if (!bookType) {
//             setErrors((e) => ({ ...e, bookType: true }));
//             valid = false;
//         }
//         if (!receiptNo) {
//             setErrors((e) => ({ ...e, receiptNo: true }));
//             valid = false;
//         }
//         if (!selectedCashBook) {
//             setErrors((e) => ({ ...e, selectedCashBook: true }));
//             valid = false;
//         }
//         if (!selectedParty) {
//             setErrors((e) => ({ ...e, selectedParty: true }));
//             valid = false;
//         }
//         if (!amount || parseFloat(amount) <= 0) {
//             setErrors((e) => ({ ...e, amount: true }));
//             valid = false;
//         }
//         if (
//             bookType === "Bank Receipt" &&
//             (!transactionNo || transactionNo.toString().trim() === "")
//         ) {
//             setErrors((e) => ({ ...e, transactionNo: true }));
//             valid = false;
//         }

//         // If BillWise, ensure each line has an inputAmount
//         if (paymentType === "BillWise") {
//             selectedBills.forEach((inv) => {
//                 if (inv.inputAmount == null || inv.inputAmount.toString().trim() === "") {
//                     setErrors((e) => ({ ...e, inputAmount: { ...e.inputAmount, [inv.invoiceId]: true }, }));
//                     valid = false;
//                 }
//             });
//         }

//         // Stop if any validation failed
//         if (!valid) {
//             showSnackbar("Please fill in all required fields", "warning");
//             return;
//         }

//         // Map each selected bill to billwiseentry
//         const billWiseEntries = selectedBills.map((inv, idx) => {
//             const amt = parseFloat(inv.inputAmount) || 0;
//             const tdsAmt = parseFloat(inv.inputTds) || 0;
//             const roundOffAmt = parseFloat(inv.inputRoundOff) || 0;
//             const totalPaid = amt + tdsAmt + roundOffAmt;

//             return {
//                 PurcInvoiceId: null,
//                 SaleInvoiceId: inv.invoiceId,
//                 SrNo: idx + 1,
//                 BillAmt: parseFloat(inv.BasicAmt) || 0,
//                 OSAMT: (parseFloat(inv.OSAmt) || 0) - amt,
//                 ChequeAmt: amt,
//                 TDSAmt: tdsAmt,
//                 RoundOffAmt: roundOffAmt,
//                 PaidAmt: totalPaid,
//                 InvoiceId: inv.invoiceId,
//                 Inv_BillNumber: inv.BillNumber,
//                 Inv_BillDate: inv.BillDate,
//                 Inv_BillAmt: parseFloat(inv.BillAmt) || 0,
//             };
//         });

//         const payload = {
//             L_NO: null,
//             PartyId: selectedParty?.id || null,
//             BankId: selectedCashBook?.id || null,
//             BookName: bookType || null,
//             ReceiptNumber: receiptNo || null,
//             ReceiptDate: receiptDate?.toISOString() || null,
//             ChequeNo: transactionNo || null,
//             Amount: amount ? parseFloat(amount) : null,
//             BankComm: bankCharges ? parseFloat(bankCharges) : 0,
//             TDSAmt: tds ? parseFloat(tds) : null,
//             RoundOffAmt: roundOff ? parseFloat(roundOff) : null,
//             PaidAmt: totalAmt ? parseFloat(totalAmt) : null,
//             VoucherNo: 0,
//             VoucherTotal: totalAmt ? parseFloat(totalAmt) : null,
//             Remarks: remark || null,
//             ClearingAmount: 0,
//             ClearingDate: null,
//             CurrencyId: selectedCurrency?.currencyId || null,
//             ExchangeRate: exchangeRate ? parseFloat(exchangeRate) : null,
//             MultiCurrency: isMultiCurrency ? 1 : 0,
//             FYear: getCurrentFYear(),
//             CompanyId: companyId,
//             BranchId: 1,
//             AddUserId: userId,
//             BillWise: paymentType === "BillWise" ? 1 : 0,
//             BillWisePaidAmt: totalAmt ? parseFloat(totalAmt) : null,
//             billWiseEntries,
//             mode: "sale"
//         };

//         console.log("payload", payload)

//         try {
//             const res = await axios.post(`${path}/api/payReceive`, payload);
//             if (res.data.success) {
//                 showSnackbar(`Saved Successfully!`, "success");
//                 setTimeout(() => { setActiveStep(0); }, 1000)
//                 handleClear();
//             } else {
//                 showSnackbar("Save failed", "error");
//             }
//         } catch (err) {
//             console.error(err);
//             showSnackbar("Error saving Receipt ", "error");
//         }
//     };

//     const handleClear = () => {
//         setBookType("Bank Receipt");
//         setCashBookTerm("");
//         setCashBookOptions([]);
//         setSelectedCashBook(null);
//         setPartyInput("");
//         setPartyOptions([]);
//         setSelectedParty(null);
//         setIsMultiCurrency(false);
//         // setCurrencySearch("");
//         // setCurrencyResults([]);
//         setSelectedCurrency(null);
//         setExchangeRate("");
//         setTransactionNo("")
//         // setReceiptNo("");
//         setAmount("");
//         setTds("");
//         setRoundOff("0");
//         setTotalAmt("");
//         setReceiptDate(today);
//         setPaymentType("BillWise");
//         setRemark("");
//         setInvoiceData([]);
//         setSelectedBills([]);
//         setBankCharges("");
//         setPendingSelectedIds([]);
//         setFetchedPartyId(null);
//         clearErrors();
//     };

//     //fetches invoices and moves to next step
//     //     const handleNextButton = async () => {
//     //         // Reset previous errors
//     //         clearErrors();

//     //         let valid = true;
//     //         if (!bookType) {
//     //             setErrors(e => ({ ...e, bookType: true }));
//     //             valid = false;
//     //         }

//     //         if (!transactionNo) {
//     //             setErrors(e => ({ ...e, transactionNo: true }));
//     //             valid = false;
//     //         }

//     //           if (!selectedCashBook) {
//     //             setErrors(e => ({ ...e, selectedCashBook: true }));
//     //             valid = false;
//     //           }

//     //         if (!selectedParty) {
//     //             setErrors(e => ({ ...e, selectedParty: true }));
//     //             valid = false;
//     //         }

//     //         if (amount.toString().trim() === "" || parseFloat(amount) <= 0) {
//     //             setErrors(e => ({ ...e, amount: true }));
//     //             valid = false;
//     //         }

//     //         if (!valid) {
//     //             alert("Please fill required fields before viewing outstanding entries.");
//     //             return;
//     //         }

//     //         if (!selectedParty?.id) {
//     //             alert("Please select a party first.");
//     //             return;
//     //         }
//     //         if (fetchedPartyId !== selectedParty.id) {
//     //             setLoadingInvoices(true);
//     //             try {
//     //                 const res = await axios.post(`${path}/api/fetch-invoice-by-client`, {
//     //                     clientId: selectedParty.id,
//     //                     clientName: selectedParty.clientname,
//     //                     companyId
//     //                 });
//     //                 const invoicesWithIndex = (res.data.invoices || []).map((inv, index) => ({
//     //                     ...inv,
//     //                     id: inv.invoiceId,
//     //                     originalIndex: index,
//     //                     BasicAmt: Number(inv.BasicAmt),
//     //   RoundOff: Number(inv.RoundOff),
//     //   BillAmt: Number(inv.BillAmt),
//     //   PaidAmt: Number(inv.PaidAmt)
//     //                 }));
//     //                 setInvoiceData(invoicesWithIndex);
//     //                 setFetchedPartyId(selectedParty.id);
//     //             } catch (err) {
//     //                 console.error(err);
//     //                 alert("Error fetching invoices.");
//     //             } finally {
//     //                 setLoadingInvoices(false);
//     //             }
//     //         }
//     //         setPendingSelectedIds([]);
//     //         setModalOpen(true);
//     //         setActiveStep(1)
//     //     };

//     useEffect(() => {
//         if (bookType !== "Bank Receipt") {
//             setErrors(e => ({
//                 ...e,
//                 transactionNo: false,
//             }));
//         }
//     }, [bookType]);

//     const handleNextButton = async () => {
//         clearErrors();

//         let valid = true;
//         if (!bookType) {
//             setErrors(e => ({ ...e, bookType: true }));
//             valid = false;
//         }

//         if (bookType === "Bank Receipt" && !transactionNo) {
//             setErrors(e => ({ ...e, transactionNo: true }));
//             valid = false;
//         }

//         if (!selectedCashBook) {
//             setErrors(e => ({ ...e, selectedCashBook: true }));
//             valid = false;
//         }

//         if (!selectedParty) {
//             setErrors(e => ({ ...e, selectedParty: true }));
//             valid = false;
//         }

//         if (amount.toString().trim() === "" || parseFloat(amount) <= 0) {
//             setErrors(e => ({ ...e, amount: true }));
//             valid = false;
//         }

//         if (!valid) {
//             showSnackbar("Please fill required fields before viewing outstanding entries", "warning");
//             return;
//         }


//         // IMPORTANT LOGIC
//         if (paymentType !== "BillWise") {
//             handleSave();   // ✅ direct save
//             return;
//         }

//         // only for BillWise
//         if (fetchedPartyId !== selectedParty.id) {
//             setLoadingInvoices(true);
//             try {
//                 const res = await axios.post(`${path}/api/fetch-invoice-by-client`, {
//                     clientId: selectedParty.id,
//                     clientName: selectedParty.clientname,
//                     companyId,
//                     mode: 'sale'
//                 });

//                 const invoicesWithIndex = (res.data.invoices || []).map((inv, index) => ({
//                     ...inv,
//                     id: inv.invoiceId,
//                     originalIndex: index,
//                     BasicAmt: Number(inv.BasicAmt),
//                     RoundOff: Number(inv.RoundOff),
//                     BillAmt: Number(inv.BillAmt),
//                     PaidAmt: Number(inv.PaidAmt),
//                     OSAmt: Number(inv.OSAmt),
//                 }));

//                 setInvoiceData(invoicesWithIndex);
//                 setAllInvoices(invoicesWithIndex);
//                 setFetchedPartyId(selectedParty.id);

//             } catch (err) {
//                 console.error(err);
//                 showSnackbar("Error fetching invoices", "error");
//             } finally {
//                 setLoadingInvoices(false);
//             }
//         }

//         setActiveStep(1); // ✅ only BillWise
//     };

//     // Removes an invoice from the selected Bill Wise list
//     // and adds it back to the pending invoices list at its original position
//     const handleDeselectInvoice = (invoice) => {
//         setSelectedBills((prev) => prev.filter((i) => i.invoiceId !== invoice.invoiceId));
//         setInvoiceData((prev) => {
//             const newData = [...prev];
//             const index = invoice.originalIndex || prev.length;
//             newData.splice(index, 0, {
//                 invoiceId: invoice.invoiceId,
//                 BillNumber: invoice.BillNumber,
//                 RefNo: invoice.RefNo,
//                 BillDate: invoice.BillDate,
//                 BasicAmt: invoice.BasicAmt,
//                 RoundOff: invoice.RoundOff,
//                 BillAmt: invoice.BillAmt,
//                 PaidAmt: invoice.PaidAmt,
//                 id: invoice.invoiceId,
//                 originalIndex: invoice.originalIndex,
//             });
//             return newData;
//         });
//     };

//     // Updates a specific input field (amount / TDS / round-off) 
//     // for a selected invoice in the Bill Wise table
//     // const handleBillFieldChange = (invoiceId, field, value) => {
//     //     setSelectedBills((prev) =>
//     //         prev.map((inv) => {
//     //             if (inv.invoiceId !== invoiceId) return inv;

//     //             const updated = { ...inv, [field]: value };

//     //             const amt = parseFloat(updated.inputAmount) || 0;
//     //             const tds = parseFloat(updated.inputTds) || 0;
//     //             const round = parseFloat(updated.inputRoundOff) || 0;

//     //             const total = amt + tds + round;

//     //             if (total > parseFloat(inv.BillAmt)) {
//     //                 //  prevent update (or clamp)
//     //                 return inv;
//     //             }

//     //             return updated;
//     //         })
//     //     );
//     // };


//     const handleBillFieldChange = (invoiceId, field, value) => {
//         setSelectedBills((prev) =>
//             prev.map((inv) => {
//                 if (inv.invoiceId !== invoiceId) return inv;

//                 const updated = {
//                     ...inv,
//                     [field]: value
//                 };

//                 //  DO NOT BLOCK — just calculate (optional)
//                 const amt = parseFloat(updated.inputAmount) || 0;
//                 const tds = parseFloat(updated.inputTds) || 0;
//                 const round = parseFloat(updated.inputRoundOff) || 0;

//                 const total = amt + tds + round;

//                 //  NO return inv here
//                 //  NO restriction here

//                 return updated;
//             })
//         );
//     };
//     // Move selected invoices from pending list to Bill Wise list
//     const handleSubmitSelected = () => {
//         // Get selected invoices based on pendingSelectedIds
//         const selectedInvoices = invoiceData.filter((inv) =>
//             pendingSelectedIds.includes(inv.invoiceId)
//         );

//         // Map selected invoices to include input fields
//         const toAdd = selectedInvoices.map((invoice) => ({
//             ...invoice,
//             inputAmount: invoice.OSAmt || "",
//             inputTds: "",
//             inputRoundOff: "",
//             inputTotalAmount: invoice.OSAmt || "",
//         }));

//         // Update selectedBills by adding new selections
//         setSelectedBills((prev) => [...prev, ...toAdd]);

//         // Remove selected invoices from invoiceData
//         setInvoiceData((prev) =>
//             prev.filter((inv) => !pendingSelectedIds.includes(inv.invoiceId))
//         );

//         // Clear selected IDs and close dialog
//         setPendingSelectedIds([]);
//         setModalOpen(false);
//     };


//     return (
//         <Box maxWidth="lg" mx="auto" px={2} py={1} pb={0}>
//             <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600, mb: 0.6 }}>
//                 Receipt
//             </Typography>


//             <Paper sx={{ p: isSm ? 1 : 2, maxWidth: 1400, mx: "auto", overflow: "hidden", borderRadius: 3, p: 1.5 }} elevation={4}>
//                 <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 2 }}>
//                     {steps.map((label) => (
//                         <Step key={label}>
//                             <StepLabel
//                                 sx={{
//                                     '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
//                                         mt: '4px', // works properly
//                                     },
//                                     '& .MuiStepLabel-iconContainer': {
//                                         pb: 0,
//                                     },
//                                 }}>{label}</StepLabel>
//                         </Step>
//                     ))}
//                 </Stepper>

//                 <Divider sx={{ mb: activeStep === 0 ? 3 : 1, mt: -1 }} />

//                 <Grid container spacing={isSm ? 1 : 2} justifyContent="center">
//                     {/* *********step-1******** */}
//                     {
//                         activeStep === 0 &&
//                         <Grid item size={{ xs: 12, md: 5.4 }}>
//                             <PaymentReceiptStepOne
//                                 setIsConfigInvalid={setIsConfigInvalid}
//                                 isConfigInvalid={isConfigInvalid}
//                                 bookType={bookType}
//                                 errors={errors}
//                                 handleBookTypeChange={handleBookTypeChange}
//                                 paymentType={paymentType}
//                                 setPaymentType={setPaymentType}
//                                 setBookType={setBookType}
//                                 selectedCashBook={selectedCashBook}
//                                 setSelectedCashBook={setSelectedCashBook}
//                                 selectedParty={selectedParty}
//                                 setSelectedParty={setSelectedParty}
//                                 amount={amount}
//                                 setAmount={setAmount}
//                                 receiptDate={receiptDate}
//                                 setReceiptDate={setReceiptDate}
//                                 receiptNo={receiptNo}
//                                 cashBookOptions={cashBookOptions}
//                                 cashBookTerm={cashBookTerm}
//                                 setCashBookTerm={setCashBookTerm}
//                                 loadingCashBook={loadingCashBook}
//                                 partyOptions={partyOptions}
//                                 partyInput={partyInput}
//                                 setPartyInput={setPartyInput}
//                                 loadingParty={loadingParty}
//                                 transactionNo={transactionNo}
//                                 setTransactionNo={setTransactionNo}
//                                 tds={tds}
//                                 setTds={setTds}
//                                 roundOff={roundOff}

//                                 setRoundOff={setRoundOff}
//                                 totalAmt={totalAmt}
//                                 isMultiCurrency={isMultiCurrency}
//                                 setIsMultiCurrency={setIsMultiCurrency}
//                                 selectedCurrency={selectedCurrency}
//                                 currencies={currencyResults}
//                                 setSelectedCurrency={setSelectedCurrency}
//                                 exchangeRate={exchangeRate}
//                                 setExchangeRate={setExchangeRate}
//                                 bankCharges={bankCharges}
//                                 setBankCharges={setBankCharges}
//                                 remark={remark}
//                                 setRemark={setRemark}
//                                 handleNextButton={handleNextButton}
//                                 isStep1ValidForBillWise={isStep1ValidForBillWise}
//                                 connectionString={connectionString}
//                                 bankCashConfig={bankCashConfig}
//                                 bookTypeOptions={bookTypeOptions[formMode]}
//                             />
//                         </Grid>
//                     }
//                 </Grid>

//                 {/* *********step-2******** */}
//                 {activeStep === 1 &&
//                     <>
//                         <PaymentReceiptStepTwo
//                             invoiceData={invoiceData}
//                             selectedBills={selectedBills}
//                             pendingSelectedIds={pendingSelectedIds}
//                             setPendingSelectedIds={setPendingSelectedIds}
//                             loadingInvoices={loadingInvoices}
//                             handleSubmitSelected={handleSubmitSelected}
//                             modalOpen={modalOpen}
//                             setModalOpen={setModalOpen}
//                             paymentType={paymentType}
//                             handleSave={handleSave}
//                             handleClear={handleClear}
//                             disableSave={disableSave}
//                             handleBillFieldChange={handleBillFieldChange}
//                             handleDeselectInvoice={handleDeselectInvoice}
//                             errors={errors}
//                             amount={amount}
//                             tds={tds}
//                             roundOff={roundOff}
//                             totalAmt={totalAmt}
//                             goback={() => { setActiveStep(0) }}
//                             handleAutoSelectBills={handleAutoSelectBills}

//                         />
//                     </>}
//             </Paper>


//             <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//                 <Alert
//                     severity={snackbar.severity}
//                     variant="filled"
//                     onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>

//         </Box>
//     );
// }







import { useState, useEffect} from "react";
import axios from "axios";
import { useAuth } from '../../context/AuthContext';
import {
    Box, Grid, Typography, Button, Paper, useTheme, useMediaQuery, Stepper, StepLabel, Step, Divider, Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import dayjs from "dayjs";
import PaymentReceiptStepOne from "../../components/PaymentReceiptStepOne";
import PaymentReceiptStepTwo from "../../components/PaymentReceiptStepTwo";
import { Snackbar, Alert } from "@mui/material";


import { useNavigate, useParams } from "react-router-dom";
import { getCurrentFYear } from '../../utils/financialYear';

export default function ReceiveableV2({ connectionString }) {
    const { user, selectedCompany, loading } = useAuth();
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const role = user?.UserCategory || null;
    const path = connectionString;
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down("sm"));
    const today = dayjs();
    const { id } = useParams();

    const isEditMode = Boolean(id);


    // --- Lookup state
    const [bookType, setBookType] = useState("BKR");
    const [cashBookTerm, setCashBookTerm] = useState("");
    const [cashBookOptions, setCashBookOptions] = useState([]);
    const [loadingCashBook, setLoadingCashBook] = useState(false);
    const [selectedCashBook, setSelectedCashBook] = useState(null);
    const [partyInput, setPartyInput] = useState("");
    const [partyOptions, setPartyOptions] = useState([]);
    const [selectedParty, setSelectedParty] = useState(null);
    const [loadingParty, setLoadingParty] = useState(false);
    const [isMultiCurrency, setIsMultiCurrency] = useState(false);
    const [currencyResults, setCurrencyResults] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [exchangeRate, setExchangeRate] = useState("");
    const [receiptNo, setReceiptNo] = useState("");
    // --- Numeric fields
    const [amount, setAmount] = useState("");
    const [tds, setTds] = useState("");
    const [roundOff, setRoundOff] = useState("0");
    const [totalAmt, setTotalAmt] = useState("");
    const [remark, setRemark] = useState("");
    const [receiptDate, setReceiptDate] = useState(dayjs());
    const [bankCharges, setBankCharges] = useState("");
    // Payment type & tables
    const [paymentType, setPaymentType] = useState("OnAccount");
    const [invoiceData, setInvoiceData] = useState([]);
    const [selectedBills, setSelectedBills] = useState([]);
    const [dbBillwiseEntries, setDbBillwiseEntries] = useState([]);
    const [transactionNo, setTransactionNo] = useState("");
    const [loadingInvoices, setLoadingInvoices] = useState(false);
    const [confirmSaveOpen, setConfirmSaveOpen] = useState(false);

    const [allInvoices, setAllInvoices] = useState([]);

    const formMode = "receipt";

    const bookTypeOptions = {
        payment: [
            { label: "Bank Payment", value: "BKP" },
            { label: "Cash Payment", value: "CBP" }
        ],
        receipt: [
            { label: "Bank Receipt", value: "BKR" },
            { label: "Cash Receipt", value: "CBR" }
        ]
    };

    // Error states
    const [errors, setErrors] = useState({ bookType: false, receiptNo: false, selectedCashBook: false, selectedParty: false, amount: false, inputAmount: {}, transactionNo: false, });

    // Modal states
    const [modalOpen, setModalOpen] = useState(false);
    const [pendingSelectedIds, setPendingSelectedIds] = useState([]);
    const [fetchedPartyId, setFetchedPartyId] = useState(null);

    const [bankCashConfig, setBankCashConfig] = useState(null);
    const [isConfigInvalid, setIsConfigInvalid] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success" // success | error | warning | info
    });

    const [paymentTypeDialogOpen, setPaymentTypeDialogOpen] = useState(false);

    const [pendingPaymentType, setPendingPaymentType] = useState(null);

    //stepper states
    const [activeStep, setActiveStep] = useState(0);
    const steps = ["Step-1", "Step-2"];

    const [resetDialogOpen, setResetDialogOpen] = useState(false);

    const navigate = useNavigate();

    const [isBillsReset, setIsBillsReset] = useState(false);



    //used to make next button disable
    // const isStep1ValidForBillWise = Boolean(bookType) && Boolean(selectedCashBook) && Boolean(selectedParty) && (bookType !== "BKR" || Boolean(transactionNo)) && amount.toString().trim() !== "" && parseFloat(amount) > 0;

    const isStep1ValidForBillWise =
        Boolean(bookType) &&
        Boolean(selectedCashBook) &&
        Boolean(selectedParty) &&
        (bookType !== "BKR" || Boolean(transactionNo)) &&
        (
            isBillsReset ||
            (
                amount.toString().trim() !== "" &&
                parseFloat(amount) > 0
            )
        );


    console.log("selectedBills", selectedBills)

    const isAdvanceWithBillAllocation =
        paymentType === "Advance" &&
        selectedBills.some((bill) => {
            return (
                (parseFloat(bill.inputAmount) || 0) > 0 ||
                (parseFloat(bill.inputTds) || 0) > 0 ||
                (parseFloat(bill.inputRoundOff) || 0) > 0
            );
        });

    useEffect(() => {

        if (paymentType === "Advance") {
            setTds("0");
            setRoundOff("0");
            setBankCharges("0");
        }

    }, [paymentType]);


    const isBillAllocationEmpty = () => {

        if (paymentType !== "BillWise") return false;

        const appliedAmount = selectedBills.reduce(
            (sum, i) => sum + (parseFloat(i.inputAmount) || 0),
            0
        );

        const appliedTds = selectedBills.reduce(
            (sum, i) => sum + (parseFloat(i.inputTds) || 0),
            0
        );

        const appliedRoundOff = selectedBills.reduce(
            (sum, i) => sum + (parseFloat(i.inputRoundOff) || 0),
            0
        );

        const appliedTotal =
            appliedAmount +
            appliedTds +
            appliedRoundOff;

        return (
            appliedAmount === 0 &&
            appliedTds === 0 &&
            appliedRoundOff === 0 &&
            appliedTotal === 0
        );
    };

    useEffect(() => {
        if (!id || !companyId) return;

        fetchReceiptById();
    }, [id, companyId]);

    //Reset Bills Function
    const handleResetBills = () => {
        setResetDialogOpen(true);
    };


    const confirmResetBills = () => {

        // clear bills
        setSelectedBills([]);
        // setInvoiceData([]);
        setInvoiceData(allInvoices)
        setPendingSelectedIds([]);
        setFetchedPartyId(null);

        // clear amount fields
        // setAmount("0");
        // setTds("0");
        // setRoundOff("0");
        // setBankCharges("0");

        setIsBillsReset(true);

        setResetDialogOpen(false);

        // optional
        // showSnackbar(
        //     "Bill allocation reset successfully.",
        //     "success"
        // );
    };

    const fetchReceiptById = async () => {
        try {

            const res = await axios.get(
                `${path}/api/get-payReceive-by-id`,
                {
                    params: {
                        receiptId: id,
                        companyId,
                        type: "receipt"
                    }
                }
            );

            console.log("edit response", res.data);

            const master = res.data?.master || {};
            const billwise = res.data?.billwise || [];

            // =========================
            // MASTER DATA
            // =========================

            setBookType(master.BookName || "BKR");

            setReceiptNo(master.ReceiptNumber || "");

            setReceiptDate(
                master.ReceiptDate
                    ? dayjs(master.ReceiptDate)
                    : dayjs()
            );

            setTransactionNo(master.ChequeNo || "");

            setAmount(master.Amount || "");

            setTds(master.TDSAmt || "");

            setRoundOff(master.RoundOffAmt || "0");

            setTotalAmt(master.PaidAmt || "");

            setRemark(master.Remarks || "");

            setBankCharges(master.BankComm || "");

            setPaymentType(
                master.BillWise === 1
                    ? "BillWise"
                    : master.IsAdvancePayment === 1
                        ? "Advance"
                        : master.OnAccount === 1
                            ? "OnAccount"
                            : "OnAccount"
            );

            setIsMultiCurrency(master.MultiCurrency === 1);

            setExchangeRate(master.ExchangeRate || "");

            // =========================
            // PARTY
            // =========================

            setSelectedParty({
                id: master.PartyId,
                clientname: master.PartyName || ""
            });

            setPartyInput(master.PartyName || "");

            // =========================
            // CASH/BANK
            // =========================

            setSelectedCashBook({
                id: master.BankId,
                accountName: master.BankName || ""
            });

            setCashBookTerm(master.BankName || "");

            // =========================
            // CURRENCY
            // =========================

            if (master.CurrencyId) {

                setSelectedCurrency({
                    currencyId: master.CurrencyId,
                    CurrencyName: master.CurrencyName || ""
                });
            }

            // =========================
            // BILLWISE
            // =========================

            if (billwise.length > 0) {

                const mappedBills = billwise.map((item, index) => ({
                    ...item,

                    id:
                        item.InvoiceId ||
                        item.SaleInvoiceId ||
                        item.PurcInvoiceId ||
                        item.Id,

                    invoiceId:
                        item.InvoiceId ||
                        item.SaleInvoiceId ||
                        item.PurcInvoiceId ||
                        item.Id,

                    originalIndex: index,

                    inputAmount: item.ChequeAmt || "",

                    inputTds: item.TDSAmt || "",

                    inputRoundOff: item.RoundOffAmt || "",

                    inputTotalAmount: item.PaidAmt || "",

                    OSAmt: item.OSAMT
                }));

                setSelectedBills(mappedBills);

                setDbBillwiseEntries(mappedBills);

                // setPaymentType("Advance");


                setIsBillsReset(false);

                // setActiveStep(1);
            }

        } catch (err) {
            console.error("Edit Fetch Error", err);
        }
    };

    // Reset invoiceData and selectedBills when party changes
    useEffect(() => {

        if (isEditMode) return;

        setInvoiceData([]);
        setSelectedBills([]);
        setFetchedPartyId(null);

    }, [selectedParty?.id]);

    const showSnackbar = (message, severity = "success") => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    };

    //function to auto select bills according to the billDate
    const handleAutoSelectBills = () => {
        if (!allInvoices || allInvoices.length === 0) return;

        const sorted = [...allInvoices].sort(
            (a, b) => new Date(a.BillDate) - new Date(b.BillDate)
        );

        let remaining = parseFloat(amount) || 0;
        const selected = [];

        for (let bill of sorted) {
            if (remaining <= 0) break;

            const billAmt = parseFloat(bill.OSAmt) || 0;

            //  If full bill fits
            if (billAmt <= remaining) {
                selected.push({
                    ...bill,
                    inputAmount: billAmt,
                    inputTds: "",
                    inputRoundOff: "",
                    inputTotalAmount: billAmt,
                });

                remaining -= billAmt;
            } else {
                //  PARTIAL ALLOCATION (IMPORTANT)
                selected.push({
                    ...bill,
                    inputAmount: remaining,
                    inputTds: "",
                    inputRoundOff: "",
                    inputTotalAmount: remaining,
                });

                remaining = 0;
            }
        }

        const selectedIds = selected.map(b => b.invoiceId);

        //  FULL RESET every time (as per your requirement)
        setSelectedBills(selected);

        //  Remaining invoices go back to pending
        setInvoiceData(allInvoices.filter(b => !selectedIds.includes(b.invoiceId)));
    };
    const fetchBankCashConfig = async (bookName) => {
        try {
            const res = await axios.get(`${path}/api/check-bankcash-config`, {
                params: {
                    compId: companyId,
                    bookName
                }
            });

            setBankCashConfig(res.data.data || []);
        } catch (err) {
            console.error("Config fetch error", err);
            setBankCashConfig(null);
        }
    };

    //fetch  tds , bank charge , round off exist info
    useEffect(() => {
        if (!bookType) return;

        // Map UI → DB BookName
        let bookName = bookType;

        if (bookName) {
            fetchBankCashConfig(bookName);
        }

    }, [bookType, companyId]);


    //Trigger receipt generation on load
    useEffect(() => {
        if (bookType) {
            fetchReceiptNo(bookType);
        }
    }, [bookType]);


    // UI state reset on bookType change
    useEffect(() => {

        // prevent clearing during edit prefill
        if (isEditMode) return;

        if (bookType === "CBR") {
            setTransactionNo("");
            setBankCharges("");
        }

        // setSelectedCashBook(null);

    }, [bookType]);

    // Helper to reset all errors
    const clearErrors = () => {
        setErrors({ bookType: false, receiptNo: false, selectedCashBook: false, selectedParty: false, amount: false, inputAmount: {}, transactionNo: false, });
    };

    const fetchCurrency = async () => {
        try {
            const res = await axios.get(`${path}/currencymaster/search?mode=search&companyId=${companyId}`);

            // IMPORTANT: set data into state
            setCurrencyResults(res.data || []);
        } catch (err) {
            console.error(err);
            setCurrencyResults([]);
        }
    };

    useEffect(() => {
        fetchCurrency()
    }, [])


    // Add row error check
    const hasRowError = selectedBills.some((row) => {
        const total =
            (parseFloat(row.inputAmount) || 0) +
            (parseFloat(row.inputTds) || 0) +
            (parseFloat(row.inputRoundOff) || 0);

        return total > parseFloat(row.OSAmt);
    });


    // Disable Save if any single inputAmount exceeds the Amount or any error
    // const disableSave = (() => {
    //     const enteredAmount = parseFloat(amount) || 0;
    //     const enteredTds = parseFloat(tds) || 0;
    //     const enteredRoundOff = parseFloat(roundOff) || 0;
    //     const enteredTotal = parseFloat(totalAmt) || 0;

    //     const appliedAmount = selectedBills.reduce(
    //         (sum, i) => sum + (parseFloat(i.inputAmount) || 0),
    //         0
    //     );

    //     const appliedTds = selectedBills.reduce(
    //         (sum, i) => sum + (parseFloat(i.inputTds) || 0),
    //         0
    //     );

    //     const appliedRoundOff = selectedBills.reduce(
    //         (sum, i) => sum + (parseFloat(i.inputRoundOff) || 0),
    //         0
    //     );

    //     const appliedTotal = appliedAmount + appliedTds + appliedRoundOff;

    //     const mismatch =
    //         appliedAmount.toFixed(2) !== enteredAmount.toFixed(2) ||
    //         appliedTds.toFixed(2) !== enteredTds.toFixed(2) ||
    //         appliedRoundOff.toFixed(2) !== enteredRoundOff.toFixed(2) ||
    //         appliedTotal.toFixed(2) !== enteredTotal.toFixed(2);

    //     // FINAL CONDITION
    //     return hasRowError || mismatch;
    // })();


    const disableSave = (() => {

        // =========================
        // REQUIRED FIELD VALIDATION
        // =========================

        if (!bookType) return true;

        if (!receiptNo) return true;

        if (!selectedCashBook?.id && !selectedCashBook?.clientId) return true;

        if (!selectedParty?.id) return true;

        // cheque no mandatory only for bank receipt
        if (
            bookType === "BKR" &&
            (!transactionNo || transactionNo.toString().trim() === "")
        ) {
            return true;
        }

        // =========================
        // AMOUNT VALIDATION
        // =========================

        // allow 0 amount only after reset
        if (
            !isBillsReset &&
            (
                amount.toString().trim() === "" ||
                parseFloat(amount) <= 0
            )
        ) {
            return true;
        }

        // =========================
        // BILLWISE VALIDATION
        // =========================

        if (paymentType === "BillWise") {

            const enteredAmount = parseFloat(amount) || 0;
            const enteredTds = parseFloat(tds) || 0;
            const enteredRoundOff = parseFloat(roundOff) || 0;
            const enteredTotal = parseFloat(totalAmt) || 0;

            const appliedAmount = selectedBills.reduce(
                (sum, i) => sum + (parseFloat(i.inputAmount) || 0),
                0
            );

            const appliedTds = selectedBills.reduce(
                (sum, i) => sum + (parseFloat(i.inputTds) || 0),
                0
            );

            const appliedRoundOff = selectedBills.reduce(
                (sum, i) => sum + (parseFloat(i.inputRoundOff) || 0),
                0
            );


            const appliedTotal =
                appliedAmount +
                appliedTds +
                appliedRoundOff;

            // const mismatch =
            //     appliedAmount.toFixed(2) !== enteredAmount.toFixed(2) ||
            //     appliedTds.toFixed(2) !== enteredTds.toFixed(2) ||
            //     appliedRoundOff.toFixed(2) !== enteredRoundOff.toFixed(2) ||
            //     appliedTotal.toFixed(2) !== enteredTotal.toFixed(2);
            const allZero =
                appliedAmount === 0 &&
                appliedTds === 0 &&
                appliedRoundOff === 0 &&
                appliedTotal === 0;

            const mismatch =
                !allZero &&
                (
                    appliedAmount.toFixed(2) !== enteredAmount.toFixed(2) ||
                    appliedTds.toFixed(2) !== enteredTds.toFixed(2) ||
                    appliedRoundOff.toFixed(2) !== enteredRoundOff.toFixed(2) ||
                    appliedTotal.toFixed(2) !== enteredTotal.toFixed(2)
                );

            return hasRowError || mismatch;

        }

        // =========================
        // ON ACCOUNT / ADVANCE
        // =========================

        return false;

    })();

    console.log("disableSave", disableSave)

    // Debounced cash-book lookup
    useEffect(() => {
        if (!bookType) {
            setCashBookOptions([]);
            return;
        }
        setLoadingCashBook(true);
        const id = setTimeout(async () => {
            try {
                // console.log({ params: { field: bookType, search: cashBookTerm, companyId }, })
                const res = await axios.get(`${path}/api/booktype-data`, { params: { field: bookType, search: cashBookTerm, companyId }, });
                setCashBookOptions(res.data.data || []);
                console.log('asgbisdbgf', res.data.data)
            } catch {
                setCashBookOptions([]);
            } finally {
                setLoadingCashBook(false);
            }
        }, 500);
        return () => clearTimeout(id);
    }, [cashBookTerm, bookType]);

    // Receipt number
    const fetchReceiptNo = async (code) => {
        try {
            const { data } = await axios.get(`${path}/api/get-receipt-no`, { params: { code, companyId }, });
            setReceiptNo(data.receiptNo || "");
        } catch {
            setReceiptNo("");
        }
    };

    console.log("selectedBills", selectedBills)

    const handleBookTypeChange = (e) => {
        const newBookType = e.target.value;

        // Only reset cashbook if switching between bank/cash category
        const wasBank = bookType === "BKR" || bookType === "BKP";
        const isNowBank = newBookType === "BKR" || newBookType === "BKP";
        const wasCategory = wasBank ? "bank" : "cash";
        const nowCategory = isNowBank ? "bank" : "cash";

        if (wasCategory !== nowCategory) {
            setSelectedCashBook(null); // ← only reset when switching bank ↔ cash
            setCashBookTerm("");
        }

        setBookType(newBookType);
    };

    // Party lookup
    useEffect(() => {
        setLoadingParty(true);
        const id = setTimeout(async () => {
            try {
                const res = await axios.get(`${path}/api/company-search`, { params: { field: "FirmName", companyId, search: partyInput.trim() || "" }, });
                const mappedOptions = (res.data.data || []).map((item) => ({ id: item.id, clientname: item.FirmName, ContactPerson: item.ContactPerson, City: item.City, MobileNo: item.MobileNo, EmailId: item.EmailId, Address: item.Address, GSTNo: item.GSTNo, state: item.state, Pincode: item.Pincode, }));
                setPartyOptions(mappedOptions);
            } catch {
                setPartyOptions([]);
            } finally {
                setLoadingParty(false);
            }
        }, 500);
        return () => clearTimeout(id);
    }, [partyInput]);

    console.log("selectedCurrency", selectedCurrency)

    // Recompute overall totalAmt
    useEffect(() => {
        const a = parseFloat(amount) || 0;
        const t = parseFloat(tds) || 0;
        const r = parseFloat(roundOff) || 0;
        setTotalAmt((a + t + r).toFixed(2));
    }, [amount, tds, roundOff]);

    // Clear currency on toggle
    useEffect(() => {

        if (!isMultiCurrency) {
            console.log("inside multicurrency******")
            // setCurrencySearch("");
            // setCurrencyResults([]);
            setSelectedCurrency(null);
            setExchangeRate("");
        }
    }, [isMultiCurrency]);


    console.log("disableSave", disableSave)

    const saveReceipt = async () => {
        // Reset previous errors
        clearErrors();

        // Run validation
        let valid = true;
        if (!bookType) {
            setErrors((e) => ({ ...e, bookType: true }));
            valid = false;
        }
        if (!receiptNo) {
            setErrors((e) => ({ ...e, receiptNo: true }));
            valid = false;
        }
        if (!selectedCashBook) {
            setErrors((e) => ({ ...e, selectedCashBook: true }));
            valid = false;
        }
        if (!selectedParty) {
            setErrors((e) => ({ ...e, selectedParty: true }));
            valid = false;
        }
        // if (!amount || parseFloat(amount) <= 0) {
        //     setErrors((e) => ({ ...e, amount: true }));
        //     valid = false;
        // }


        if (
            !isBillsReset &&
            (
                amount.toString().trim() === "" ||
                parseFloat(amount) <= 0
            )
        ) {
            setErrors(e => ({ ...e, amount: true }));
            valid = false;
        }
        if (
            bookType === "BKR" &&
            (!transactionNo || transactionNo.toString().trim() === "")
        ) {
            setErrors((e) => ({ ...e, transactionNo: true }));
            valid = false;
        }

        // If BillWise, ensure each line has an inputAmount
        // if (paymentType === "BillWise") {
        //     selectedBills.forEach((inv) => {
        //         if (inv.inputAmount == null || inv.inputAmount.toString().trim() === "") {
        //             setErrors((e) => ({ ...e, inputAmount: { ...e.inputAmount, [inv.invoiceId]: true }, }));
        //             valid = false;
        //         }
        //     });
        // }

        // Stop if any validation failed
        if (!valid) {
            showSnackbar("Please fill in all required fields", "warning");
            return;
        }

        // Map each selected bill to billwiseentry
        // const billWiseEntries = selectedBills.map((inv, idx) => {
        //     const amt = parseFloat(inv.inputAmount) || 0;
        //     const tdsAmt = parseFloat(inv.inputTds) || 0;
        //     const roundOffAmt = parseFloat(inv.inputRoundOff) || 0;
        //     const totalPaid = amt + tdsAmt + roundOffAmt;

        //     return {
        //         PurcInvoiceId: null,
        //         SaleInvoiceId: inv.invoiceId,
        //         BookName: inv.BookName,
        //         EntryModule: bookType,
        //         SrNo: idx + 1,
        //         BillAmt: parseFloat(inv.BasicAmt) || 0,
        //         OSAMT: Number(inv.OSAmt),
        //         ChequeAmt: amt,
        //         TDSAmt: tdsAmt,
        //         RoundOffAmt: roundOffAmt,
        //         PaidAmt: totalPaid,
        //         InvoiceId: inv.invoiceId,
        //         Inv_BillNumber: inv.BillNumber,
        //         Inv_BillDate: inv.BillDate,
        //         Inv_BillAmt: parseFloat(inv.BillAmt) || 0,

        //     };
        // });

        const hasAnyBillAllocation = selectedBills.some((inv) => {
            return (
                (parseFloat(inv.inputAmount) || 0) > 0 ||
                (parseFloat(inv.inputTds) || 0) > 0 ||
                (parseFloat(inv.inputRoundOff) || 0) > 0
            );
        });

        const billWiseEntries = hasAnyBillAllocation
            ? selectedBills
                .filter((inv) => {

                    const amt = parseFloat(inv.inputAmount) || 0;
                    const tdsAmt = parseFloat(inv.inputTds) || 0;
                    const roundOffAmt = parseFloat(inv.inputRoundOff) || 0;

                    // only include rows having some value
                    return (
                        amt > 0 ||
                        tdsAmt > 0 ||
                        roundOffAmt > 0
                    );
                })
                .map((inv, idx) => {

                    const amt = parseFloat(inv.inputAmount) || 0;
                    const tdsAmt = parseFloat(inv.inputTds) || 0;
                    const roundOffAmt = parseFloat(inv.inputRoundOff) || 0;

                    const totalPaid =
                        amt +
                        tdsAmt +
                        roundOffAmt;

                    return {
                        PurcInvoiceId: null,
                        SaleInvoiceId: inv.invoiceId,
                        BookName: inv.BookName,
                        EntryModule: bookType,
                        SrNo: idx + 1,
                        BillAmt: parseFloat(inv.BasicAmt) || 0,
                        OSAMT: Number(inv.OSAmt),
                        ChequeAmt: amt,
                        TDSAmt: tdsAmt,
                        RoundOffAmt: roundOffAmt,
                        PaidAmt: totalPaid,
                        InvoiceId: inv.invoiceId,
                        Inv_BillNumber: inv.BillNumber,
                        Inv_BillDate: inv.BillDate,
                        Inv_BillAmt: parseFloat(inv.BillAmt) || 0,
                    };
                })
            : [];



        // ✅ FIXED PAYLOAD WITH ALL REQUIRED FIELDS
        const payload = {
            L_NO: null,
            PartyId: selectedParty?.id || null,
            BankId: selectedCashBook?.clientId || selectedCashBook?.id || null,                   // ✅ FIXED: clientId instead of id
            BookName: bookType || null,
            ReceiptNumber: receiptNo || null,
            ReceiptDate: receiptDate?.toISOString() || null,
            ChequeNo: transactionNo || null,
            Amount: amount ? parseFloat(amount) : null,
            BankComm: bankCharges ? parseFloat(bankCharges) : 0,
            TDSAmt: tds ? parseFloat(tds) : null,
            RoundOffAmt: roundOff ? parseFloat(roundOff) : null,
            PaidAmt: totalAmt ? parseFloat(totalAmt) : null,
            VoucherNo: 0,
            VoucherTotal: totalAmt ? parseFloat(totalAmt) : null,
            Remark: remark || null,                                        // ✅ FIXED: Remarks → Remark
            ClearingAmount: 0,
            ClearingDate: null,
            CurrencyId: selectedCurrency?.currencyId || null,
            ExchangeRate: exchangeRate ? parseFloat(exchangeRate) : null,
            MultiCurrency: isMultiCurrency ? 1 : 0,
            FYear: getCurrentFYear(),
            CompanyId: companyId,
            BranchId: 1,
            AddUserId: userId,
            BillWise: paymentType === "BillWise" ? 1 : 0,
            IsAdvancePayment: paymentType === "Advance" ? 1 : 0,
            OnAccount: paymentType === "OnAccount" ? 1 : 0,
            paymentType: paymentType,
            BillWisePaidAmt: totalAmt ? parseFloat(totalAmt) : null,
            billWiseEntries,
            mode: "sale",
            TDSAccountId: bankCashConfig?.TDSAccountId || null,
            RoundOffAccountId: bankCashConfig?.RoundOffAccountId || null,
            BankCommAccountId: bankCashConfig?.BankCommAccountId || null,
            BookTypeId: selectedCashBook?.bookTypeId || null,
            ReceiptId: id || null,
        };

        console.log("payload", payload)

        try {
            let res = []
            // const res = await axios.post(`${path}/api/payReceive`, payload);
            if (isEditMode) {

                res = await axios.put(
                    `${path}/api/update-payReceive`,
                    payload
                );

            } else {

                res = await axios.post(
                    `${path}/api/payReceive`,
                    payload
                );
            }

            if (res.data.success) {
                showSnackbar(`Saved Successfully!`, "success");
                setTimeout(() => { navigate("/main/receivable-details") }, 1000)
                handleClear();
            } else {
                showSnackbar("Save failed", "error");
            }
        } catch (err) {
            console.error(err);
            showSnackbar("Error saving Receipt ", "error");
        }


    };

    // Handle Save
    const handleSave = async () => {
        // if (paymentType === "BillWise" && disableSave) return;
        if (disableSave) return;

        // show confirmation before saving
        if (isBillAllocationEmpty()) {
            setConfirmSaveOpen(true);
            return;
        }

        await saveReceipt();
    };


    const handleClear = () => {
        setBookType("BKR");
        setCashBookTerm("");
        setCashBookOptions([]);
        setSelectedCashBook(null);
        setPartyInput("");
        setPartyOptions([]);
        setSelectedParty(null);
        setIsMultiCurrency(false);
        // setCurrencySearch("");
        // setCurrencyResults([]);
        setSelectedCurrency(null);
        setExchangeRate("");
        setTransactionNo("")
        // setReceiptNo("");
        setAmount("");
        setTds("");
        setRoundOff("0");
        setTotalAmt("");
        setReceiptDate(today);
        setPaymentType("OnAccount");
        setRemark("");
        setInvoiceData([]);
        setSelectedBills([]);
        setBankCharges("");
        setPendingSelectedIds([]);
        setFetchedPartyId(null);
        clearErrors();
        setTimeout(() => {
            fetchReceiptNo("BKR");  // Generate new receipt number for Bank Payment
        }, 100);
        navigate(-1)
    };

    //fetches invoices and moves to next step
    //     const handleNextButton = async () => {
    //         // Reset previous errors
    //         clearErrors();

    //         let valid = true;
    //         if (!bookType) {
    //             setErrors(e => ({ ...e, bookType: true }));
    //             valid = false;
    //         }

    //         if (!transactionNo) {
    //             setErrors(e => ({ ...e, transactionNo: true }));
    //             valid = false;
    //         }

    //           if (!selectedCashBook) {
    //             setErrors(e => ({ ...e, selectedCashBook: true }));
    //             valid = false;
    //           }

    //         if (!selectedParty) {
    //             setErrors(e => ({ ...e, selectedParty: true }));
    //             valid = false;
    //         }

    //         if (amount.toString().trim() === "" || parseFloat(amount) <= 0) {
    //             setErrors(e => ({ ...e, amount: true }));
    //             valid = false;
    //         }

    //         if (!valid) {
    //             alert("Please fill required fields before viewing outstanding entries.");
    //             return;
    //         }

    //         if (!selectedParty?.id) {
    //             alert("Please select a party first.");
    //             return;
    //         }
    //         if (fetchedPartyId !== selectedParty.id) {
    //             setLoadingInvoices(true);
    //             try {
    //                 const res = await axios.post(`${path}/api/fetch-invoice-by-client`, {
    //                     clientId: selectedParty.id,
    //                     clientName: selectedParty.clientname,
    //                     companyId
    //                 });
    //                 const invoicesWithIndex = (res.data.invoices || []).map((inv, index) => ({
    //                     ...inv,
    //                     id: inv.invoiceId,
    //                     originalIndex: index,
    //                     BasicAmt: Number(inv.BasicAmt),
    //   RoundOff: Number(inv.RoundOff),
    //   BillAmt: Number(inv.BillAmt),
    //   PaidAmt: Number(inv.PaidAmt)
    //                 }));
    //                 setInvoiceData(invoicesWithIndex);
    //                 setFetchedPartyId(selectedParty.id);
    //             } catch (err) {
    //                 console.error(err);
    //                 alert("Error fetching invoices.");
    //             } finally {
    //                 setLoadingInvoices(false);
    //             }
    //         }
    //         setPendingSelectedIds([]);
    //         setModalOpen(true);
    //         setActiveStep(1)
    //     };

    useEffect(() => {
        if (bookType !== "BKR") {
            setErrors(e => ({
                ...e,
                transactionNo: false,
            }));
        }
    }, [bookType]);

    const handleNextButton = async () => {
        clearErrors();

        let valid = true;
        if (!bookType) {
            setErrors(e => ({ ...e, bookType: true }));
            valid = false;
        }

        if (bookType === "BKR" && !transactionNo) {
            setErrors(e => ({ ...e, transactionNo: true }));
            valid = false;
        }

        if (!selectedCashBook) {
            setErrors(e => ({ ...e, selectedCashBook: true }));
            valid = false;
        }

        if (!selectedParty) {
            setErrors(e => ({ ...e, selectedParty: true }));
            valid = false;
        }

        if (
            !isBillsReset &&
            (
                amount.toString().trim() === "" ||
                parseFloat(amount) <= 0
            )
        ) {
            setErrors(e => ({ ...e, amount: true }));
            valid = false;
        }

        if (!valid) {
            showSnackbar("Please fill required fields before viewing outstanding entries", "warning");
            return;
        }


        // IMPORTANT LOGIC
        // if (paymentType === "OnAccount") {
        //     handleSave();   // ✅ direct save
        //     return;
        // }

        const hasExistingBillwiseEntries =
            dbBillwiseEntries?.length > 0;

        if (
            paymentType === "OnAccount" ||
            (
                paymentType === "Advance" &&
                !hasExistingBillwiseEntries
            )
        ) {
            handleSave();
            return;
        }

        // only for BillWise
        if (fetchedPartyId !== selectedParty.id) {
            setLoadingInvoices(true);
            try {
                const res = await axios.post(`${path}/api/fetch-invoice-by-client`, {
                    clientId: selectedParty.id,
                    clientName: selectedParty.clientname,
                    companyId,
                    mode: 'sale'
                });

                const invoicesWithIndex = (res.data.invoices || []).map((inv, index) => ({
                    ...inv,
                    id: inv.invoiceId,
                    originalIndex: index,
                    BasicAmt: Number(inv.BasicAmt),
                    RoundOff: Number(inv.RoundOff),
                    BillAmt: Number(inv.BillAmt),
                    PaidAmt: Number(inv.PaidAmt),
                    OSAmt: Number(inv.OSAmt),
                }));

                setInvoiceData(invoicesWithIndex);
                setAllInvoices(invoicesWithIndex);
                setFetchedPartyId(selectedParty.id);

            } catch (err) {
                console.error(err);
                showSnackbar("Error fetching invoices", "error");
            } finally {
                setLoadingInvoices(false);
            }
        }

        setActiveStep(1); // ✅ only BillWise
    };

    // Removes an invoice from the selected Bill Wise list
    // and adds it back to the pending invoices list at its original position
    // const handleDeselectInvoice = (invoice) => {

    //     setSelectedBills((prev) =>
    //         prev.filter((i) => i.invoiceId !== invoice.invoiceId)
    //     );

    //     setInvoiceData((prev) => {

    //         // already exists → don't add again
    //         const alreadyExists = prev.some(
    //             (i) => i.invoiceId === invoice.invoiceId
    //         );

    //         if (alreadyExists) {
    //             return prev;
    //         }

    //         const newData = [...prev];

    //         const index = invoice.originalIndex || prev.length;

    //         newData.splice(index, 0, {
    //             invoiceId: invoice.invoiceId,
    //             BillNumber: invoice.BillNumber,
    //             RefNo: invoice.RefNo,
    //             BillDate: invoice.BillDate,
    //             BasicAmt: invoice.BasicAmt,
    //             RoundOff: invoice.RoundOff,
    //             BillAmt: invoice.BillAmt,
    //             PaidAmt: invoice.PaidAmt,
    //             OSAmt: invoice.OSAmt || invoice.OSAMT || 0,
    //             id: invoice.invoiceId,
    //             originalIndex: invoice.originalIndex,
    //         });

    //         return newData;
    //     });
    // };

    const handleDeselectInvoice = (invoice) => {

        // remove from selected
        setSelectedBills((prev) =>
            prev.filter((i) => i.invoiceId !== invoice.invoiceId)
        );

        setInvoiceData((prev) => {

            // remove old duplicate row first
            const filtered = prev.filter(
                (i) => i.invoiceId !== invoice.invoiceId
            );

            // restore ORIGINAL invoice from allInvoices
            const originalInvoice = allInvoices.find(
                (i) => i.invoiceId === invoice.invoiceId
            );

            // if not found, don't modify
            if (!originalInvoice) {
                return filtered;
            }

            const newData = [...filtered];

            const index =
                invoice.originalIndex >= 0
                    ? invoice.originalIndex
                    : filtered.length;

            newData.splice(index, 0, {
                ...originalInvoice,
                originalIndex: invoice.originalIndex,
            });

            return newData;
        });
    };

    // Updates a specific input field (amount / TDS / round-off) 
    // for a selected invoice in the Bill Wise table
    // const handleBillFieldChange = (invoiceId, field, value) => {
    //     setSelectedBills((prev) =>
    //         prev.map((inv) => {
    //             if (inv.invoiceId !== invoiceId) return inv;

    //             const updated = { ...inv, [field]: value };

    //             const amt = parseFloat(updated.inputAmount) || 0;
    //             const tds = parseFloat(updated.inputTds) || 0;
    //             const round = parseFloat(updated.inputRoundOff) || 0;

    //             const total = amt + tds + round;

    //             if (total > parseFloat(inv.BillAmt)) {
    //                 //  prevent update (or clamp)
    //                 return inv;
    //             }

    //             return updated;
    //         })
    //     );
    // };


    const handleBillFieldChange = (invoiceId, field, value) => {
        setSelectedBills((prev) =>
            prev.map((inv) => {
                if (inv.invoiceId !== invoiceId) return inv;

                const updated = {
                    ...inv,
                    [field]: value
                };

                //  DO NOT BLOCK — just calculate (optional)
                const amt = parseFloat(updated.inputAmount) || 0;
                const tds = parseFloat(updated.inputTds) || 0;
                const round = parseFloat(updated.inputRoundOff) || 0;

                const total = amt + tds + round;

                //  NO return inv here
                //  NO restriction here

                return updated;
            })
        );
    };
    // Move selected invoices from pending list to Bill Wise list
    const handleSubmitSelected = () => {
        // Get selected invoices based on pendingSelectedIds
        const selectedInvoices = invoiceData.filter((inv) =>
            pendingSelectedIds.includes(inv.invoiceId)
        );

        // Map selected invoices to include input fields
        const toAdd = selectedInvoices.map((invoice) => ({
            ...invoice,
            inputAmount: "",
            inputTds: "",
            inputRoundOff: "",
            inputTotalAmount: "",
        }));

        // Update selectedBills by adding new selections
        setSelectedBills((prev) => [...prev, ...toAdd]);

        // Remove selected invoices from invoiceData
        setInvoiceData((prev) =>
            prev.filter((inv) => !pendingSelectedIds.includes(inv.invoiceId))
        );

        // Clear selected IDs and close dialog
        setPendingSelectedIds([]);
        setModalOpen(false);
    };


    const handlePaymentTypeChange = (newType) => {

        // no change
        if (newType === paymentType) return;

        const hasBillWiseEntries =
            dbBillwiseEntries.some((bill) => {
                return (
                    (parseFloat(bill.inputAmount) || 0) > 0 ||
                    (parseFloat(bill.inputTds) || 0) > 0 ||
                    (parseFloat(bill.inputRoundOff) || 0) > 0
                );
            });

        // switching FROM BillWise → another type
        if (
            paymentType === "BillWise" &&
            newType !== "BillWise" &&
            hasBillWiseEntries
        ) {

            setPendingPaymentType(newType);

            setPaymentTypeDialogOpen(true);

            return;
        }

        // normal change
        setPaymentType(newType);
    };


    const confirmPaymentTypeChange = () => {

        setSelectedBills([]);

        setInvoiceData([]);
        setDbBillwiseEntries([]);

        setPendingSelectedIds([]);

        setFetchedPartyId(null);

        setIsBillsReset(false);

        setPaymentType(pendingPaymentType);

        setPendingPaymentType(null);

        setPaymentTypeDialogOpen(false);
    };


    const cancelPaymentTypeChange = () => {

        setPendingPaymentType(null);

        setPaymentTypeDialogOpen(false);
    };


    return (
        <Box maxWidth="lg" mx="auto" px={2} py={1} pb={0}>
            <Typography variant="h5" sx={{ textAlign: 'center', fontSize: { xs: '1.25rem', sm: '1.5rem' }, fontWeight: 600, mb: 0.6 }}>
                {isEditMode ? 'Edit' : "Add New"}{" "}Receipt
            </Typography>


            <Paper sx={{ p: isSm ? 1 : 2, maxWidth: 1400, mx: "auto", overflow: "hidden", borderRadius: 3, p: 1.5 }} elevation={4}>
                <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 2 }}>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel
                                sx={{
                                    '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
                                        mt: '4px', // works properly
                                    },
                                    '& .MuiStepLabel-iconContainer': {
                                        pb: 0,
                                    },
                                }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                <Divider sx={{ mb: activeStep === 0 ? 3 : 1, mt: -1 }} />

                <Grid container spacing={isSm ? 1 : 2} justifyContent="center">
                    {/* *********step-1******** */}
                    {
                        activeStep === 0 &&
                        <Grid item size={{ xs: 12, md: 5.4 }}>
                            <PaymentReceiptStepOne
                                isEditMode={isEditMode}
                                setIsConfigInvalid={setIsConfigInvalid}
                                isConfigInvalid={isConfigInvalid}
                                bookType={bookType}
                                errors={errors}
                                handleBookTypeChange={handleBookTypeChange}
                                paymentType={paymentType}
                                setPaymentType={handlePaymentTypeChange}
                                setBookType={setBookType}
                                selectedCashBook={selectedCashBook}
                                setSelectedCashBook={setSelectedCashBook}
                                selectedParty={selectedParty}
                                setSelectedParty={setSelectedParty}
                                amount={amount}
                                setAmount={setAmount}
                                receiptDate={receiptDate}
                                setReceiptDate={setReceiptDate}
                                receiptNo={receiptNo}
                                cashBookOptions={cashBookOptions}
                                cashBookTerm={cashBookTerm}
                                setCashBookTerm={setCashBookTerm}
                                loadingCashBook={loadingCashBook}
                                partyOptions={partyOptions}
                                partyInput={partyInput}
                                setPartyInput={setPartyInput}
                                loadingParty={loadingParty}
                                transactionNo={transactionNo}
                                setTransactionNo={setTransactionNo}
                                tds={tds}
                                setTds={setTds}
                                roundOff={roundOff}

                                setRoundOff={setRoundOff}
                                totalAmt={totalAmt}
                                isMultiCurrency={isMultiCurrency}
                                setIsMultiCurrency={setIsMultiCurrency}
                                selectedCurrency={selectedCurrency}
                                currencies={currencyResults}
                                setSelectedCurrency={setSelectedCurrency}
                                exchangeRate={exchangeRate}
                                setExchangeRate={setExchangeRate}
                                bankCharges={bankCharges}
                                setBankCharges={setBankCharges}
                                remark={remark}
                                setRemark={setRemark}
                                handleNextButton={handleNextButton}
                                isStep1ValidForBillWise={isStep1ValidForBillWise}
                                connectionString={connectionString}
                                bankCashConfig={bankCashConfig}
                                bookTypeOptions={bookTypeOptions[formMode]}
                                isBillsReset={isBillsReset}
                                disableSave={disableSave}
                                isAdvanceWithBillAllocation={isAdvanceWithBillAllocation}
                                selectedBills={selectedBills}
                            />
                        </Grid>
                    }
                </Grid>

                {/* *********step-2******** */}
                {activeStep === 1 &&
                    <>
                        <PaymentReceiptStepTwo
                            invoiceData={invoiceData}
                            selectedBills={selectedBills}
                            pendingSelectedIds={pendingSelectedIds}
                            setPendingSelectedIds={setPendingSelectedIds}
                            loadingInvoices={loadingInvoices}
                            handleSubmitSelected={handleSubmitSelected}
                            modalOpen={modalOpen}
                            setModalOpen={setModalOpen}
                            paymentType={paymentType}
                            handleSave={handleSave}
                            handleClear={handleClear}
                            disableSave={disableSave}
                            handleBillFieldChange={handleBillFieldChange}
                            handleDeselectInvoice={handleDeselectInvoice}
                            errors={errors}
                            amount={amount}
                            tds={tds}
                            roundOff={roundOff}
                            totalAmt={totalAmt}
                            goback={() => { setActiveStep(0) }}
                            handleAutoSelectBills={handleAutoSelectBills}
                            handleResetBills={handleResetBills}
                            isEditMode={isEditMode}
                            isBillsReset={isBillsReset}

                        />
                    </>}
            </Paper>


            <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                <Alert
                    severity={snackbar.severity}
                    variant="filled"
                    onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>



            <Dialog
                open={resetDialogOpen}
                onClose={() => setResetDialogOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Remove Bill Allocation
                </DialogTitle>

                <DialogContent>

                    <Typography>
                        This will remove all entered bill allocations. Are you sure to continue ?
                    </Typography>

                </DialogContent>

                <DialogActions>

                    <Button
                        onClick={() => setResetDialogOpen(false)}
                        variant="outlined"
                    >
                        Cancel
                    </Button>

                    <Button
                        color="error"
                        variant="contained"
                        onClick={confirmResetBills}
                    >
                        Remove All Bills
                    </Button>

                </DialogActions>
            </Dialog>


            <Dialog
                open={confirmSaveOpen}
                onClose={() => setConfirmSaveOpen(false)}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>
                    Confirm Save
                </DialogTitle>

                <DialogContent>
                    <Typography sx={{ mt: 1 }}>
                        Are you sure you want to continue saving without bill allocations?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => setConfirmSaveOpen(false)}
                        variant="outlined"
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={async () => {
                            setConfirmSaveOpen(false);
                            await saveReceipt();
                        }}
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={paymentTypeDialogOpen}
                onClose={cancelPaymentTypeChange}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>
                    Remove Bill Allocations
                </DialogTitle>

                <DialogContent>

                    <Typography sx={{ mt: 1 }}>
                        Changing the payment type will remove all bill allocations.
                    </Typography>

                    <Typography sx={{ mt: 1, fontWeight: 500 }}>
                        Do you want to continue?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button onClick={cancelPaymentTypeChange} variant="outlined">
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        onClick={confirmPaymentTypeChange}
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    );
}